<template>
  <div class="card" style="padding:2%">
    <div class="" style="padding-bottom:20px">
      <div class="row">
        <div class="col-md-12">
          <span style="font-size: 22px; font-weight: 600;">Ingresar nuevos pacientes</span> <br>
          <span style="padding-bottom:-10px" class="texto-pequeno">Formulario de ingreso de paciente</span>
        </div>
      </div>
    </div>
    <div>
      <br />
      <center>
        <button type="button" class="btn btn-secondary btn-fill btn-sm" @click="abrirModal()">
          <i class="fa fa-search"></i> Buscar un paciente
        </button>
        <button type="button" class="btn btn-danger btn-sm" @click="limpiarFormulario()">
          <i class="fa fa-history"></i> Limpiar Formulario
        </button>
      </center>
    </div>

    <div class="card-body" style="padding:4%">
      <form @submit.prevent="agregarPaciente">
        <span style="font-size: 19px; font-weight: 500;">Información personal</span>

        <center>
          <div>
            <br />
            <div
              v-bind:style="estado==0?'height:190px;':'border: 0px #e3097e solid;   width: 170px; height: 150px;'"
            >
              <img
                :src="fotoPaciente"
                class="img-thumbnail"
                alt="Cargar foto del paciente"
                id="documentos"
              />
            </div>
            <br />
            <div v-bind:style="estado==0?'display:none':''">
              <input
                type="file"
                @change="functionFotoPaciente"
                id="fotoPaciente"
                style="display:none;"
                accept=".jpg, .png"
              />
              <label
                v-if="nombrefotoPaciente!=null"
                class="btn btn-success btn-sm"
                for="fotoPaciente"
                id="buttonImg"
              >
                <i class="fa fa-check"></i>
                Imagen seleccionada
              </label>
              <label v-else class="btn btn-success btn-sm" for="fotoPaciente">
                <i class="fa fa-file-image-o"></i>
                Cargar Fotografía del paciente
              </label>
              <br />
            </div>
          </div>

          <!-- <label for="">Imagen de la orden medica:</label> -->
        </center>
        <br />
        <br />
        <div class="row">
          <div class="col-md-3 col-xs-12" v-if="controlBoton=='registrar'">
            <label for="tipo_documento">
              Tipo de documento
              <small>*</small>
            </label>
            <select v-model="tipoDocumento" id="tipo_documento" class="form-control select-sm">
              <option value disabled>Seleccionar</option>
              <option
                v-for="documento in arrayTipoDocumento"
                :key="documento.TipDocCod"
                :value="documento.TipDocCod"
                v-text="documento.TipDocNom"
              ></option>
            </select>
          </div>
          <div class="col-md-3 col-xs-12" v-else>
            <label for="tipo_documento">
              Tipo de documento
              <small>*</small>
            </label>
            <select
              v-model="tipoDocumento"
              id="tipo_documento"
              
              class="form-control select-sm"
            >
              <option value disabled>Seleccionar</option>
              <option
                v-for="documento in arrayTipoDocumento"
                :key="documento.TipDocCod"
                :value="documento.TipDocCod"
                v-text="documento.TipDocNom"
              ></option>
            </select>
          </div>

          <div class="col-md-3" v-if="controlBoton=='registrar'">
            <label for="documento_paciente">
              N° documento
              <small>*</small>
            </label>
            <input
              type="text"
              v-model="numeroDocumento"
              @change="llamarPacienteExistente()"
              required
              class="form-control input-sm"
              id="documento_paciente"
            />
          </div>
          <div class="col-md-3" v-else>
            <label for="documento_paciente">
              N° documento
              <small>*</small>
            </label>
            <input
              
              type="text"
              v-model="numeroDocumento"
              @change="llamarPacienteExistente()"
              required
              class="form-control input-sm"
              id="documento_paciente"
            />
          </div>
          <div class="col-md-3 col-xs-12">
            <label for="apellidos_paciente">
              Apellidos
              <small>*</small>
            </label>
            <input
              type="text"
              required
              v-model="apellidos"
              class="form-control input-sm"
              id="apellidos_paciente"
            />
          </div>
          <div class="col-md-3 col-xs-12">
            <label for="nombres_paciente">
              Nombres
              <small>*</small>
            </label>
            <input
              type="text"
              v-model="nombres"
              required
              class="form-control input-sm"
              id="nombres_paciente"
            />
          </div>
        </div>
        <!-- segunda fila -->
        <div class="row">
          <div class="col-md-3 col-xs-12">
            <label for="fecha_nacimiento">
              Fecha de nacimiento
              <small>*</small>
            </label>
            <input
              required
              type="date"
              v-model="Fecha_nacimiento"
              @change="calcularEdad()"
              class="form-control input-sm"
              id="fecha_nacimiento"
            />
          </div>
          <div class="col-md-3">
            <label for>
              Sexo
              <small>*</small>
            </label>
            <select v-model="sexo" class="form-control select-sm">
              <option value="1">Masculino</option>
              <option value="2">Femenino</option>
              <option value="3">Gay</option>
              <option value="4">Lesbiana</option>
              <option value="5">Bisexual</option>
              <option value="6">Transgénero</option>
              <option value="7">Intersexual</option>
              <option value="8">Sin definir</option>
            </select>
          </div>

          <div class="col-md-3">
            <label for="fecha_ing_paciente">
              Fecha de registro
              <small>*</small>
            </label>
            <input
              type="date"
              v-if="controlBoton=='registrar'"
              v-model="fechaIngreso"
              required
              :max="fechaIngreso"
              class="form-control input-sm"
              id="fecha_ing_paciente"
            />
            <input
              type="date"
              v-model="fechaIngreso"
              v-else
              disabled
              class="form-control input-sm"
              id="fecha_ing_paciente"
            />
          </div>
          <div class="col-md-3">
            <label for>
              Tipo de vinculación
              <small>*</small>
            </label>
            <select v-model="tipoCliente" required class="form-control select-sm">
              <option value disabled>Seleccionar</option>
              <option
                v-for="cliente in arrayTipoCliente"
                :key="cliente.TipCliCod"
                :value="cliente.TipCliCod"
                v-text="cliente.TipCliNom"
              ></option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <br />
            <strong
              v-if="Fecha_nacimiento!='' && Fecha_nacimiento<fechaActual"
            >{{anos}} años y {{meses}} meses</strong>
            <strong
              v-if="Fecha_nacimiento>fechaActual"
            >La fecha de nacimiento no puede ser mayor a la fecha actual</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <label for="">
              Estado civil
            </label>
            <select class="form-control select-sm" id="">
              <option value="1">SOLTERO</option>
              <option value="2">CASADO</option>
              <option value="3">DIVORCIADO</option>
              <option value="4">VIUDO</option>
            </select>
          </div>
           <div class="col-md-3">
            <label for="">
              Ocupación
            </label>
            <select class="form-control select-sm" id="">
               <option value disabled>Seleccionar</option>
                <option value="1">EMPLEADO</option>
                <option value="2">COMERCIANTE</option>
                <option value="7">EMPRESARIO</option>
                <option value="3">AMA DE CASA</option>
                <option value="4">PROFESIÓN INDEPENDIENTE</option>
                <option value="5">ESTUDIANTE</option>
                <option value="8">SIN OCUPACION</option>
                <option value="6">OTRO</option>
            </select>
          </div>
        </div>
        <br />
        <br />

        <!-- datos de origen -->

        <strong>Datos de origen:</strong>
        <!-- primera fila -->
        <div class="row">
          <div class="col-md-4">
            <label for>País:</label>
            <select name v-model="paisOrigen" class="form-control select-sm">
              <option value disabled>Seleccionar</option>
              <option
                v-for="pais in arrayPaises"
                :key="pais.PaiCod"
                :value="pais.PaiCod"
                v-text="pais.PaiNom"
              ></option>
            </select>
          </div>

          <div class="col-md-4">
            <label for>Departamento/Estado:</label>
            <select name v-model="departamentoOrigen" class="form-control select-sm">
              <option value disabled>Seleccionar</option>
              <option
                v-for="departamento in arrayDepartamentos"
                :key="departamento.DepCod"
                :value="departamento.DepCod"
                v-text="departamento.DepNom"
              ></option>
            </select>
          </div>
          <div class="col-md-4">
            <label for>Ciudad:</label>
            <select v-model="ciudadOrigen" class="form-control select-sm">
              <option value="0" disabled>Seleccione</option>
              <option
                v-for="ciudad in arrayCiudades"
                :key="ciudad.ciuCod"
                :value="ciudad.ciuCod"
                v-text="ciudad.ciuNom"
              ></option>
            </select>
          </div>
        </div>
        <br />
        <!-- datos de residencia y contacto -->
        <strong>Datos de residencia y contacto:</strong>
        <!-- primera fila -->
        <div class="row">
          <div class="col-md-4">
            <label for="pais">País:</label>
            <select id="pais" v-model="paisResidencia" class="form-control select-sm">
              <option value disabled>Seleccionar</option>
              <option
                v-for="pais in arrayPaises"
                :key="pais.PaiCod"
                :value="pais.PaiCod"
                v-text="pais.PaiNom"
              ></option>
            </select>
          </div>

          <div class="col-md-4">
            <label for="departamento">Departamento:</label>
            <select
              id="departamento"
              v-model="departamentoResidencia"
              class="form-control select-sm"
            >
              <option value disabled>Seleccionar</option>
              <option
                v-for="departamento in arrayDepartamentos"
                :key="departamento.DepCod"
                :value="departamento.DepCod"
                v-text="departamento.DepNom"
              ></option>
            </select>
          </div>
          <div class="col-md-4">
            <label for="ciudad">Ciudad:</label>
            <select id="ciudad" v-model="ciudadResidencia" class="form-control select-sm">
              <option value disabled>Seleccione</option>
              <option
                v-for="ciudad in arrayCiudades"
                :key="ciudad.ciuCod"
                :value="ciudad.ciuCod"
                v-text="ciudad.ciuNom"
              ></option>
            </select>
          </div>
        </div>
        <!-- segunda fila -->
        <div class="row">
          <div class="col-md-4">
            <label for="direccion">Dirección de residencia:</label>
            <input
              type="text"
              v-model="direccionResidencia"
              class="form-control input-sm"
              id="direccion"
            />
          </div>
          <div class="col-md-4">
            <label for="telefono_paciente">Teléfono:</label>
            <input
              type="number"
              v-model="telefonoContacto"
              class="form-control input-sm"
              id="telefono_paciente"
            />
          </div>
          <div class="col-md-4">
            <label for="email_paciente">Email:</label>
            <input
              type="email"
              v-model="emailContacto"
              class="form-control input-sm"
              id="email_paciente"
            />
          </div>
        </div>
        <br />
        <!-- datos de afiliacion -->
        <strong>Cobertura en salud:</strong>
        <br />
        <br />Régimen:
        <div class="row">
          <div class="col-6">
            <div class="col-md-3" v-for="radio in radioRegimen" :key="radio.value">
              <input type="radio" v-model="regimen" :value="radio.value" :id="radio.nombre" />
              <label :for="radio.nombre" v-text="radio.nombre"></label>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-4">
            <label for>EPS:</label>

            <select v-model="eps" class="form-control select-sm">
              <option value="16" disabled>N/A</option>
              <option
                v-for="eps in arrayEps"
                :key="eps.EpsCod"
                :value="eps.EpsCod"
                v-text="eps.EpsNom"
              ></option>
            </select>
          </div>
          <div class="col-md-4">
            <label for>Prepagada:</label>

            <select v-model="prepagada" class="form-control select-sm">
              <option value="16">N/A</option>
              <option
                v-for="prepagada in arrayPrepagada"
                :key="prepagada.EpsCod"
                :value="prepagada.EpsCod"
                v-text="prepagada.EpsNom"
                :disabled="regimen == 2 || poliza != '16'"
              ></option>
            </select>
          </div>
          <div class="col-md-4">
            <label for>Póliza:</label>
            <select v-model="poliza" class="form-control select-sm">
              <option value="16">N/A</option>
              <option
                v-for="poliza in arrayPoliza"
                :key="poliza.EpsCod"
                :value="poliza.EpsCod"
                v-text="poliza.EpsNom"
                :disabled="regimen == 2 || prepagada != '16'"
              ></option>
            </select>
          </div>
        </div>
        <br />
        <!-- datos del acudiente -->
        <strong>Datos del acompañante y remitente:</strong>
        <div class="row">
          <br />
          <div class="col-md-4">
            <label for>Nombre del acompañante:</label>
            <input type="text" v-model="nombreAcompanante" class="form-control input-sm" />
          </div>

          <div class="col-md-4">
            <label for>Teléfono del acompañante:</label>
            <input type="number" v-model="telefonoAcompanante" class="form-control input-sm" />
          </div>
          <div class="col-md-4">
            <label for>Remitido por:</label>
            <input
              type="text"
              v-model="remitente"
              class="form-control input-sm"
              title="Ej. Doctor remitente, colegio, conocido, red social instagram, pagina web, etc"
            />
            <br />
            <br />
          </div>
        </div>
        <center>
          <button
            type="submit"
            v-if="controlBoton == 'registrar' && Fecha_nacimiento<fechaActual"
            class="btn btn-success btn-sm btn-fill"
          >
            <i class="fa fa-plus"></i> Registrar Paciente
          </button>
          <button
            type="button"
            v-if="controlBoton== 'editar' && Fecha_nacimiento<fechaActual && estado == 1"
            @click="actualizarPaciente()"
            class="btn btn-success btn-sm btn-fill"
          >
            <i class="fa fa-pencil"></i> Editar Datos
          </button>
        </center>
      </form>
    </div>

    <div class="" style="padding-bottom:20px">
      <div class="row">
        <div class="col-md-7">
          <span style="font-size: 22px; font-weight: 600;">Formulario de acudientes</span><br>
          <span class="texto-pequeno">Formulario de ingreso de responsables</span>
        </div>
      </div>
    </div>
    <br />
    <form @submit.prevent="agregarAcudiente">
      <div class="card-body" style="padding:4%;">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="apellidos_acudientess">
                Apellidos
                <small style="color:red;">*</small>
              </label>
              <input
                type="text"
                v-model="apellidosAcudiente"
                class="form-control input-sm"
                id="apellidos_acudientess"
                required
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="nombre_acudiente">
                Nombres
                <small style="color:red;">*</small>
              </label>
              <input
                type="text"
                v-model="nombresAcudiente"
                class="form-control input-sm"
                id="nombre_acudiente"
                required
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="documento_acudiente">
                Tipo de documento
                <small style="color:red;">*</small>
              </label>
              <select v-model="tipoDocumentoAcudiente" class="form-control select-sm" required>
                <option value disabled>Seleccionar</option>
                <option
                  v-for="documento in arrayTipoDocumento"
                  :key="documento.TipDocCod"
                  :value="documento.TipDocCod"
                  v-text="documento.TipDocNom"
                ></option>
              </select>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="documento_acudiente">
                N° documento
                <small style="color:red;">*</small>
              </label>
              <input
                type="text"
                v-model="documentoAcudiente"
                class="form-control input-sm"
                required
              />
            </div>
          </div>
        </div>
        <!-- segunda fila -->
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for>
                Parentesco
                <small style="color:red;">*</small>
              </label>
              <select name v-model="parentesco" class="form-control select-sm">
                <option value disabled>Seleccionar</option>
                <option value="1">MADRE</option>
                <option value="2">PADRE</option>
                <option value="3">ABUELA</option>
                <option value="4">ABUELO</option>
                <option value="5">HERMANO(a)</option>
                <option value="6">TIO(a)</option>
                <option value="8">CUIDADOR(a)</option>
                <option value="9">AMIGO(a)</option>
                <option value="9">ESPOSO(a)/PAREJA</option>
                <option value="7">OTRO</option>
              </select>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="telefono_acudiente">
                Teléfono
                <small style="color:red;">*</small>
              </label>
              <input
                type="number"
                v-model="telefonoAcudiente"
                class="form-control input-sm"
                id="telefono_acudiente"
              />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="correo_acudiente">
                Correo
                <small style="color:red;">*</small>
              </label>
              <input
                type="email"
                v-model="correo"
                class="form-control input-sm"
                id="correo_acudiente"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="parentesco">
                Ocupación
                <small style="color:red;">*</small>
              </label>
              <select name v-model="ocupacion" class="form-control select-sm">
                <option value disabled>Seleccionar</option>
                <option value="1">EMPLEADO</option>
                <option value="2">COMERCIANTE</option>
                <option value="7">EMPRESARIO</option>
                <option value="3">AMA DE CASA</option>
                <option value="4">PROFESIÓN INDEPENDIENTE</option>
                <option value="5">ESTUDIANTE</option>
                <option value="8">SIN OCUPACION</option>
                <option value="6">OTRO</option>
              </select>
            </div>
          </div>
        </div>
        <br />
        <center>
          <div class="col-xs-12 col-md-12">
            <button type="submit" class="btn btn-success btn-sm btn-fill" v-if="PacIde!='' && estado == 1">
              <i class="fa fa-plus"></i> Registrar acudiente
            </button>
            <button type="button" @click="limpiarFormulario2()"  v-if="estado==1" class="btn btn-danger btn-sm">
              <i class="fa fa fa-history"></i> Limpiar formulario
            </button>
          </div>
          <br />
          <br />
        </center>
        <br />
        <br />
        <br />
        <div class="el-table">
          <table
            class="el-table el--table-hover el-table-condensed el--table-striped"
            style="margin:0;"
          >
            <thead>
              <tr>
                <th>Nombre Completo</th>
                <th>Documento</th>
                <th>Parentesco</th>
                <th>Teléfono</th>
                <th>Correo electrónico</th>
                <th>Ocupación</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="acudiente in arrayAcudientes"
                :key="acudiente.nombres"
                v-bind:style="acudiente.id==1?'color:red':''"
              >
                <td v-text="acudiente.TerNom  + ' ' +  acudiente.TerApe"></td>
                <td v-text="acudiente.TerIde"></td>
                <td v-text="acudiente.RolNom"></td>
                <td v-text="acudiente.TerTel"></td>
                <td v-text="acudiente.TerEma"></td>
                <td v-text="acudiente.OcuNom"></td>
                <td>
                  <center>
                    <button
                      @click="eliminarAcudiente(acudiente)"
                      class="btn btn-simple btn-danger btn-icon"
                      type="button"
                    >
                      <i class="fa fa-close"></i>
                    </button>
                  </center>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
    <div  style="padding-bottom:20px">
      <div class="row">
        <div class="col-md-7">
          <span style="font-size: 22px; font-weight: 600;">Registrar motivo de consulta</span> <br>
          <span class="texto-pequeno">Formulario de ingreso de motivos de consulta</span>
        </div>
      </div>
    </div>
    <div class="card-body" style="padding:4%">
      <div class="row">
        <label for="motivoConsulta">Motivo de consulta:</label>
        <textarea
          v-model="motivoConsulta"
          class="form-control"
          id="motivoConsulta"
          cols="20"
          rows="5"
          maxlength="1000"
        ></textarea>
      </div>
      <br />
      <center>
        <button @click="nuevoMotivoConsulta()" class="btn btn-success btn-fill btn-sm" v-if="estado==1">
          <i class="fa fa-plus"></i>
          Nuevo motivo de consulta
        </button>
        <button type="button" @click="limpiarMotivoDeConsulta()" class="btn btn-danger btn-sm" v-if="estado==1">
          <i class="fa fa-history"></i> Limpiar formulario
        </button>
      </center>
      <br />
      <br />
      <center>
        <el-table class="table-striped" :data="arrayMotivo" v-if="arrayMotivo!=''">
          <el-table-column label="#" type="index"></el-table-column>
          <el-table-column label="Fecha">
            <template slot-scope="props">{{props.row.MotFec | date}}</template>
          </el-table-column>
          <el-table-column prop="MotDes" label="Motivo de consulta" width="300"></el-table-column>
          <el-table-column prop="MotTer" width="135" label="Terapeuta"></el-table-column>
          <el-table-column label="Estado" width="135">
            <template slot-scope="props">
              <div v-if="props.row.MotEst==0">
                <span slot="title-label" class="label label-warning">
                  <i class="ti-close"></i> Por verificar
                </span>
              </div>
              <div v-if="props.row.MotEst==1">
                <span slot="title-label" class="label label-info">
                  <i class="ti-check"></i> Verificado
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Acciones" width="85">
                  <template slot-scope="props">
                    <center>
                      <a
                        v-if="props.row.MotEst==0"
                        class="btn btn-simple btn-warning btn-xs"
                        @click=" motivoVerificar(props.row)"
                        data-target="#modalMotivoV"
                      >
                        <i class="ti-check"></i>
                      </a>

                      <a
                        v-else
                        class="btn btn-simple btn-warning btn-xs"
                        @click="motivoVerificar(props.row)"
                        data-toggle="modal"
                        data-target="#modalMotivoV2"
                      >
                        <i class="ti-eye"></i>
                      </a>
                    </center>
                  </template>
          </el-table-column>-->
        </el-table>
      </center>
    </div>

    <div class="" style="padding-bottom:20px">
      <div class="row">
        <div class="col-md-7">
          <span style="font-size: 22px; font-weight: 600;">Registrar documentos</span> <br>
          <span class="texto-pequeno">Formulario de ingreso de documentos</span>
        </div>
      </div>
    </div>

    <div class="card-body" style="padding:4%">
      <div class="row">
        <br />

        <div class="col-md-4">
          <br />
            <!-- <label for="">Imagen de documento  de identidad:</label> -->
            <label for>Documento del paciente:</label>
            <input
              type="file"
              @change="functionFotoDocumento"
              accept=".jpg, .png, .pdf"
              style="display:none;"
              id="image1"
            />
            <label
              v-if="nombreFotoDocumento!=null"
              class="btn btn-primary"
              for="image1"
              id="botonConImagen"
            >
              <i class="fa fa-check"></i>
              {{nombreFotoDocumento}}
            </label>
            <label v-else class="btn btn-success" for="image1" id="buttonImg">
              <i class="fa fa-file-image-o"></i> Documento Paciente
            </label>
            <br />

            <a
              v-if="UrlDoc!='' && UrlDoc!=null"
              target="_blank"
              :href="'https://avanti-erp.com/'+UrlDoc"
            >Ver Documento...</a>
            <!-- <img :src="fotoDocumento" id="documentos" v-if="fotoDocumento" alt=""> -->
        </div>
        <div class="col-md-4">
          <br />
            <!-- <label for="">Imagen del acudiente</label> -->
            <label for>Documento de acudiente:</label>
            <input
              type="file"
              id="image2"
              @change="functionFotoAcudiente"
              accept=".jpg, .png, .pdf"
              style="display:none;"
            />
            <label
              v-if="nombreFotoAcudiente!=null"
              class="btn btn-primary"
              for="image2"
              id="botonConImagen"
            >
              <i class="fa fa-check"></i>
              {{nombreFotoAcudiente}}
            </label>
            <label v-else class="btn btn-success" for="image2" id="buttonImg">
              <i class="fa fa-file-image-o"></i> Documento del acudiente
            </label>
            <br />
            <a
              v-if="UrlAcu!='' && UrlAcu != null"
              target="_blank"
              :href="'https://avanti-erp.com/'+UrlAcu"
            >Ver Documento...</a>
            <!-- <img id="documentos" :src="fotoPadre " v-if="fotoPadre" alt="">-->
        </div>
        <div class="col-md-4">
          <br />

            <!-- <label for="">Imagen de la orden medica:</label> -->
            <label for>Consentimiento informado:</label>
            <input
              type="file"
              id="image3"
              @change="functionConsentimientoInformado"
              style="display:none;"
              accept=".jpg, .png, .pdf"
            />
            <label
              v-if="nombreConsentimientoInfor!=null"
              class="btn btn-primary"
              for="image3"
              id="botonConImagen"
            >
              <i class="fa fa-check"></i>
              {{nombreConsentimientoInfor}}
            </label>
            <label v-else class="btn btn-success" for="image3" id="buttonImg">
              <i class="fa fa-file-image-o"></i>Consentimiento informado
            </label>
            <br />
            <a
              v-if="UrlCon!='' && UrlCon != null"
              target="_blank"
              :href="'https://avanti-erp.com/'+UrlCon"
            >Ver Documento...</a>
            <!-- <img :src="fotoMadre" id="documentos" v-if="fotoMadre" alt=""> -->
        </div>
      </div>
      <!--fila 2-->
      <div class="row">
        <br />

        <div class="col-md-4">
          <br />

            <!-- <label for="">Imagen de la orden medica:</label> -->
            <label for>Orden médica:</label> <br>
            <input
              type="file"
              id="image4"
              accept=".jpg, .png, .pdf"
              @change="functionOrdenMedica"
              style="display:none;"
            />
            <label
              v-if="nombreordenMedica!=null"
              class="btn btn-primary"
              for="image4"
              id="botonConImagen"
            >
              <i class="fa fa-check"></i>
              {{nombreordenMedica}}
            </label>
            <label v-else class="btn btn-success" for="image4" id="buttonImg">
              <i class="fa fa-file-image-o"></i> Orden Médica
            </label>
            <br />
            <a
              v-if="UrlOrd!='' && UrlOrd != null"
              target="_blank"
              :href="'https://avanti-erp.com/'+UrlOrd"
            >Ver Documento...</a>
            <!-- <img :src="fotoOrdenMedica" v-if="fotoOrdenMedica" id="documentos" alt=""> -->

        </div>
        <div class="col-md-4">
          <br />
            <!-- <label for="">Imagen de la orden medica:</label> -->
            <label for>Autorización:</label> <br>
            <input
              type="file"
              id="image5"
              accept=".jpg, .png, .pdf"
              @change="functionAutorizacion"
              style="display:none;"
            />
            <label
              v-if="nombreAutorizacion!=null"
              class="btn btn-primary"
              for="image5"
              id="botonConImagen"
            >
              <i class="fa fa-check"></i>
              : {{nombreAutorizacion}}
            </label>
            <label v-else class="btn btn-success" for="image5" id="buttonImg">
              <i class="fa fa-file-image-o"></i>Autorización
            </label>
            <br />
            <a
              v-if="UrlAut!='' && UrlAut!=null"
              target="_blank"
              :href="'https://avanti-erp.com/'+UrlAut"
            >Ver Documento...</a>

        </div>
        <div class="col-md-4">
          <br />
  
            <!-- <label for="">Imagen de la orden medica:</label> -->
            <label for>Otro documento:</label> <br>
            <input
              type="file"
              id="image6"
              accept=".jpg, .png, .pdf"
              @change="functionImagen2"
              style="display:none;"
            />
            <label
              v-if="nombreimagen2!=null"
              class="btn btn-primary"
              for="image6"
              id="botonConImagen"
            >
              <i class="fa fa-check"></i>
              {{nombreimagen2}}
            </label>
            <label v-else class="btn btn-success" for="image6" id="buttonImg">
              <i class="fa fa-file-image-o"></i>Seleccione un archivo
            </label>
            <br />
            <a
              v-if="UrlArc!='' && UrlArc != null"
              target="_blank"
              :href="'https://avanti-erp.com/'+UrlArc"
            >Ver Documento...</a>

        </div>
      </div>
      <br />
      <br />
      <center>
        <button class="btn btn-success btn-sm btn-fill" @click="cargarDocumentos()" v-if="estado==1">
          <i class="fa fa-plus"></i> Cargar Documentos
        </button>
        <button type="button" @click="limpiarFormulario3()" class="btn btn-danger btn-sm" v-if="estado==1">
          <i class="fa fa-history"></i> Limpiar formulario
        </button>
      </center>
    </div>
    <!-- 
    primer modal-->
    <modal
      name="buscar"
      :scrollable="true"
      :draggable="true"
      width="700"
      height="auto"
      :reset="true"
    >
      <br />
      <div>
        <div>
          <div class="modal-header" style="padding-right:5px; padding-top:0">
            <div class="row">
              <div class="col-md-1">
                <i class="fa fa-search text-success" style="font-size:37px"></i>
              </div>
              <div class="col-md-7">
                <p class="titulo-modal">BUSCAR PACIENTES</p>
                <p class="texto-pequeno">Formulario de busqueda de pacientes</p>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <form @submit.prevent="buscarPacientes()">
              <div class="row">
                <div class="col-md-3">
                  <select class="form-control select-sm" v-model="criterio">
                    <option value="PacApe1">Apellidos del paciente</option>
                    <option value="PacNom1">Nombres del paciente</option>
                  </select>
                </div>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model="busqueda"
                    required
                    @keyup.enter="buscarPacientes()"
                    class="form-control input-sm"
                  />
                </div>
                <div class="col-md-1">
                  <button type="submit" class="btn btn-success btn-sm btn-simple">
                    <i style="font-size:22px" class="fa fa-search"></i>
                  </button>
                  <!-- <button @click="otraBusqueda()" class="btn btn-secondary btn-sm">
                          <i class="fa fa-history"></i>
                  </button>-->
                </div>
              </div>
            </form>
            <br />
            <br />
            <div class="col-md-12" v-if="arrayPacientes!=''">
              <div class="table-responsive">
                <table class="el-table table-striped table-sm table-condensed">
                  <thead>
                    <tr>
                      <th style="text-align: center">Nombres</th>
                      <th style="text-align: center">Apellidos</th>
                      <th style="text-align: center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="paciente in arrayPacientes" :key="paciente.PacIde">
                      <td style="text-align: center" v-text="paciente.PacNom1"></td>
                      <td style="text-align: center" v-text="paciente.PacApe1"></td>
                      <td style="text-align: center">
                        <button
                          @click="llamarPacienteExistente2(paciente)"
                          class="btn btn-success btn-simple"
                          style="padding:1px"
                        >
                          <i class="fa fa-check"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="arrayPacientes==''">
              <center>
                <i class="fa fa-info"></i>
                <strong>NO HAY PACIENTES</strong>
              </center>
            </div>
          </div>
          <div class="modal-footer" style="padding-bottom:0">
            <!-- <center> -->

            <button
              type="button"
              class="btn btn-danger btn-block btn-icon btn-simple"
              @click="cerrarModal()"
            >
              <i class="fa fa-close"></i> CERRAR
            </button>
            <!-- </center> -->
          </div>
          <br />
        </div>
      </div>
    </modal>
    <!-- fin primer modal -->
  </div>
</template>


<script>
import axios from "axios";
import swal from "sweetalert2";
import { Table, TableColumn, Select, Option } from "element-ui";

export default {
  data() {
    return {
      // fecha actual
      fechaActual: "",
      // busqueda
      criterio: "PacApe1",
      busqueda: "",
      arrayPacientes: [],
      // spinner
      spinner: 1,
      color: "#FF1873",
      loading: true,
      anos: 0,
      meses: 0,

      // datos paciente
      tipoDocumento: 4,
      numeroDocumento: "",
      apellidos: "",
      nombres: "",
      fechaIngreso: "",
      tipoCliente: "",
      Fecha_nacimiento: "",
      sexo: 1,
      paisOrigen: 1,
      departamentoOrigen: 1,
      ciudadOrigen: 1,
      paisResidencia: 1,
      departamentoResidencia: 1,
      ciudadResidencia: 1,
      direccionResidencia: "",
      barrioResidencia: "",
      telefonoContacto: "",
      eps: 16,
      poliza: 16,
      prepagada: 16,
      regimen: 1,
      emailContacto: "",
      tipoVinculacion: "",
      nombreAcompanante: "",
      telefonoAcompanante: "",
      remitente: "",
      ultimoAgregado: "",
      tipoDocumentoUltimoAgregado: "",
      PacIde: "",
      estado: 0,

      // documentos

      UrlDoc: "",
      UrlAcu: "",
      UrlArc: "",
      UrlOrd: "",
      UrlAut: "",
      UrlCon: "",

      // datos acudiente
      apellidosAcudiente: "",
      nombresAcudiente: "",
      tipoDocumentoAcudiente: "",
      documentoAcudiente: "",
      parentesco: "",
      telefonoAcudiente: "",
      correo: "",
      ocupacion: "",
      id: 1,
      arrayAcudientes: [],

      // control de vinculacion
      epsp: 1,

      // consulta
      fechaConsulta: "",
      motivoConsulta: "",
      modalRegistrar: 0,

      // vinculacion a avanza
      tipoVinculacionAvanza: "",

      // selects
      arrayCiudades: [],
      arrayDepartamentos: [],
      arrayPaises: [],
      arrayEps: [],
      arrayPrepagada: [],
      arrayPoliza: [],
      arrayTipoDocumento: [],
      arrayTipoCliente: [],
      icono: "bell",
      mensaje: "no hay datos de pacientes",

      // radios

      radioRegimen: [
        {
          nombre: "Contributivo",
          value: 1,
        },
        {
          nombre: "Subsidiado",
          value: 2,
        },
      ],

      // fotos
      // foto paciente
      nombrefotoPaciente: null,
      fotoPaciente: [],
      fotoEnviar: [],

      // foto documento
      nombreFotoDocumento: null,
      fotoDocumento: [],
      documentoIdentidad: [],
      // foto padre
      nombreFotoAcudiente: null,
      fotoAcudiente: [],
      // foto madre
      nombreConsentimientoInfor: null,
      fotoConsentimiento: [],
      // foto orden medica
      nombreordenMedica: null,
      ordenMedica: [],
      // autotizacion
      nombreAutorizacion: null,
      fotoAutorizacion: [],
      nombreimagen2: null,
      foto2: [],
      arrayMotivo: [],

      lista: [],

      // buscar

      buscar: "",

      // botones

      controlBoton: "registrar",
      controlBotonAcudiente: 0,
      estado: 1,
      // ip
      ip: "https://avanti-erp.com/",
      // notificaciones
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
    };
  },
  methods: {
    buscarPacientes() {
      this.$modal.show("carga");
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      this.arrayPacientes = [];
      var url =
        this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      axios
        .get(url, config)
        .then((response) => {
          this.arrayPacientes = response.data.data;
          this.$modal.hide("carga");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // nuevo paciente
    agregarPaciente() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/nuevoPaciente";
      axios
        .post(
          url,
          {
            PacNom1: this.nombres.toUpperCase(),
            PacNom2: "",
            PacApe1: this.apellidos.toUpperCase(),
            PacApe2: "",
            PacFecNac: this.Fecha_nacimiento,
            TipCod: this.tipoDocumento,
            PacNumDoc: this.numeroDocumento,
            PaiCodOri: this.paisOrigen,
            DepCodOri: this.departamentoOrigen,
            CiuCodOri: this.ciudadOrigen,
            PaiCodRes: this.paisResidencia,
            DepCodRes: this.departamentoResidencia,
            CiuCodRes: this.ciudadResidencia,
            EpsCod: this.eps,
            PacReg: this.regimen,
            PacTipVin: this.tipoVinculacion,
            PacNomAco: this.nombreAcompanante.toUpperCase(),
            PacTelAco: this.telefonoAcompanante,
            PacRem: this.remitente.toUpperCase(),
            PacTel: this.telefonoContacto,
            TipCliCod: this.tipoCliente,
            PacSex: this.sexo,
            PacBar: this.barrioResidencia,
            PacDir: this.direccionResidencia,
            fotoPaciente: this.fotoEnviar,
            nombreFotoPaciente: this.nombrefotoPaciente,
            PolCod: this.poliza,
            PreCod: this.prepagada,
            PacFecIng: this.fechaIngreso,
            sede: localStorage.getItem('sede'),
            emailContacto: this.emailContacto
          },
          config
        )
        .then((response) => {
          if (response.data.status == true) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<span>-<b> Paciente registrado con éxito!</b>.</span>`,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type[color],
            });
            this.calcularFechaActual();
            this.buscarUltimoAgregado();
            this.controlBoton = "editar";
          } else {
            this.$notify({
              component: {
                template: `<span>Lo sentimos!<b> Ocurrió un error, intentelo de nuevo!</b>.</span>`,
              },
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["danger"],
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    buscarUltimoAgregado() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var valor = this.numeroDocumento;
      var tipo = this.tipoDocumento;
      var url = this.ip + "api/ultimoPaciente/" + tipo + "/" + valor;
      axios
        .get(url, config)
        .then((response) => {
          console.log(response);
          this.PacIde = response.data.data[0].PacIdeUsu;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    cargarDocumentos() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/guardarDocumentos";
      if (this.PacIde == "") {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: `<span>-<b> Faltan datos del paciente!</b>.</span>`,
          },
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: this.type[color],
        });
      }

      if (
        this.nombreFotoDocumento != "" &&
        this.nombreFotoAcudiente != "" &&
        this.nombreConsentimientoInfor != "" &&
        this.nombreordenMedica != "" &&
        this.nombreAutorizacion != ""
      ) {
        axios
          .post(
            url,
            {
              // datos del paciente
              documentoPaciente: this.numeroDocumento,
              // documentoDocumento
              documentoIdentidad: this.documentoIdentidad,
              nombreDocumento: this.nombreFotoDocumento,

              // documentos del acudiente
              documentoAcudiente: this.fotoAcudiente,
              nombreDocumentoAcudiente: this.nombreFotoAcudiente,
              // consentimiento informado
              consentimientoInformado: this.fotoConsentimiento,
              nombreConsentimientoInformado: this.nombreConsentimientoInfor,
              // orden medica
              ordenMedica: this.ordenMedica,
              nombreOrdenMedica: this.nombreordenMedica,
              // autorizacion
              autorizacion: this.fotoAutorizacion,
              nombreAutorizacion: this.nombreAutorizacion,
              archivo: this.foto2,
              nombreArchivo: this.nombreimagen2,
              id: this.PacIde,

              // 'ordenMedica' : this.ordenMedica
            },
            config
          )
          .then((response) => {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<span>!<b> Documentos registrados con éxito!</b>.</span>`,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type[color],
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: `<span>-<b> No hay documentos para guardar!</b>.</span>`,
          },
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: this.type[color],
        });
      }
    },
    agregarAcudiente() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/nuevoTercero";

      if (
        this.parentesco != "" &&
        this.documentoAcudiente != "" &&
        this.tipoDocumentoAcudiente != "" &&
        this.nombresAcudiente != "" &&
        this.apellidosAcudiente != "" &&
        this.telefonoAcudiente != ""
      ) {
        axios
          .post(
            url,
            {
              TerRolCod: this.parentesco,
              TipDocTer: this.tipoDocumentoAcudiente,
              TerIde: this.documentoAcudiente,
              TipDocPac: this.tipoDocumentoUltimoAgregado,
              PacIde: this.PacIde,
              TerNom: this.nombresAcudiente.toUpperCase(),
              TerApe: this.apellidosAcudiente.toUpperCase(),
              TerTel: this.telefonoAcudiente,
              TerEma: this.correo,
              OcuCodTer: this.ocupacion,
            },
            config
          )
          .then((response) => {
            this.nombresAcudiente = "";
            this.documentoAcudiente = "";
            this.apellidosAcudiente = "";
            this.telefonoAcudiente = "";
            this.correo = "";
            this.parentesco = "";
            this.tipoDocumentoAcudiente = "";
            this.ocupacion = "";
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<span>!<b>Acudiente registrado con éxito!</b>.</span>`,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type[color],
            });
            this.llamarAcudientesDePaciente();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: `<span>-<b> Faltan campos por llenar!</b>.</span>`,
          },
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: this.type[color],
        });
      }
    },

    actualizarPaciente() {
      this.$modal.show("carga");
      var url = this.ip + "api/actualizarPaciente";
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };

      axios
        .put(
          url,
          {
            PacNom1: this.nombres.toUpperCase(),
            PacApe1: this.apellidos.toUpperCase(),
            PacFecNac: this.Fecha_nacimiento,
            PacNumDoc: this.numeroDocumento,
            TipCod: this.tipoDocumento,
            PaiCodOri: this.paisOrigen,
            DepCodOri: this.departamentoOrigen,
            CiuCodOri: this.ciudadOrigen,
            PaiCodRes: this.paisResidencia,
            DepCodRes: this.departamentoResidencia,
            CiuCodRes: this.ciudadResidencia,
            EpsCod: this.eps,
            PolCod: this.poliza,
            PreCod: this.prepagada,
            PacReg: this.regimen,
            PacTipVin: this.tipoVinculacion,
            PacNomAco: this.nombreAcompanante.toUpperCase(),
            PacTelAco: this.telefonoAcompanante,
            PacRem: this.remitente.toUpperCase(),
            PacTel: this.telefonoContacto,
            TipCliCod: this.tipoCliente,
            PacSex: this.sexo,
            PacBar: this.barrioResidencia,
            PacDir: this.direccionResidencia,
            fotoPaciente: this.fotoEnviar,
            nombreFotoPaciente: this.nombrefotoPaciente,
            PacIdeUsu: this.PacIde,
            PacFecIng: this.fechaIngreso,
            emailContacto: this.emailContacto
          },
          config
        )
        .then((response) => {
          this.$modal.hide("carga");
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: ` <div style="padding: 3%;">
              <span><b> PACIENTE ACTUALIZADO CON ÉXITO </b>.</span>
              </div>
              `,
            },
            icon: "fa fa-check",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: this.type[color],
          });
          // console.log(this.fotoEnviar);
          this.calcularEdad();
        })
        .catch((error) => {
          this.$modal.hide("carga");
          console.log(error);
        });
    },

    functionFotoPaciente(e) {
      let reader = new FileReader();
      const fotoPaciente = e.target.files[0];
      this.nombrefotoPaciente = e.target.files[0].name;
      this.fotoPaciente = URL.createObjectURL(fotoPaciente);
      reader.readAsDataURL(fotoPaciente);
      reader.onload = (e) => {
        this.fotoEnviar = e.target.result;
      };
      // console.log(this.nombrefotoPaciente);
      // console.log(this.fotoEnviar);
    },
    functionFotoDocumento(e) {
      let reader = new FileReader();
      const documento = e.target.files[0];
      this.nombreFotoDocumento = e.target.files[0].name;
      reader.readAsDataURL(documento);
      reader.onload = (e) => {
        this.documentoIdentidad = e.target.result;
      };
      // console.log(this.documentoIdentidad);
    },
    functionFotoAcudiente(e) {
      let reader = new FileReader();
      const fotoAcudiente = e.target.files[0];
      this.nombreFotoAcudiente = e.target.files[0].name;
      reader.readAsDataURL(fotoAcudiente);
      reader.onload = (e) => {
        this.fotoAcudiente = e.target.result;
      };
      // console.log(this.fotoAcudiente);
    },
    functionConsentimientoInformado(e) {
      let reader = new FileReader();
      const fotoConsentimiento = e.target.files[0];
      this.nombreConsentimientoInfor = e.target.files[0].name;
      reader.readAsDataURL(fotoConsentimiento);
      reader.onload = (e) => {
        this.fotoConsentimiento = e.target.result;
      };
      // console.log(this.fotoConsentimiento);
    },
    functionOrdenMedica(e) {
      let reader = new FileReader();
      const fotoOrdenMedica = e.target.files[0];
      this.nombreordenMedica = e.target.files[0].name;
      reader.readAsDataURL(fotoOrdenMedica);
      reader.onload = (e) => {
        this.ordenMedica = e.target.result;
      };
      // console.log(this.ordenMedica);
    },
    functionAutorizacion(e) {
      let reader = new FileReader();
      const autorizacion = e.target.files[0];
      this.nombreAutorizacion = e.target.files[0].name;
      reader.readAsDataURL(autorizacion);
      reader.onload = (e) => {
        this.fotoAutorizacion = e.target.result;
      };
      // console.log(this.fotoAutorizacion);
    },
    functionImagen2(e) {
      let reader = new FileReader();
      const imagen2 = e.target.files[0];
      this.nombreimagen2 = e.target.files[0].name;
      reader.readAsDataURL(imagen2);
      reader.onload = (e) => {
        this.foto2 = e.target.result;
      };
      // console.log(this.foto2);
    },

    selectCiudad() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/selectCiudad";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayCiudades = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    selectDepartamento() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/selectDepartamento";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayDepartamentos = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    selectPais() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/selectPais";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayPaises = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    selectEps() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/selectEps?reg=" + this.regimen;
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayEps = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectPrepagada() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "/api/selectPrepagada";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayPrepagada = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectPoliza() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "/api/selectPoliza";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayPoliza = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectTipoDocumento() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/tipoDocumento";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayTipoDocumento = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    selectTipoCliente() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/tipoCliente";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayTipoCliente = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    llamarPacienteExistente() {
      this.$modal.show("carga");
      this.fotoPaciente = [];
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };

      if (this.numeroDocumento != "") {
        var buscar = this.numeroDocumento;
        var buscar2 = this.tipoDocumento;
        var url = this.ip + "api/paciente/" + buscar2 + "/" + buscar;
        axios
          .get(url, config)
          .then((response) => {
            this.$modal.hide("carga");
            if (response.data.data != 0) {
              var respuesta = response.data.data[0];
              this.tipoDocumento = respuesta.TipCod;
              this.nombres = respuesta.PacNom1;
              this.apellidos = respuesta.PacApe1;
              this.Fecha_nacimiento = respuesta.PacFecNac;
              this.sexo = respuesta.PacSex;
              this.fechaIngreso = respuesta.PacFecIng;
              this.tipoCliente = respuesta.TipCliCod;
              this.paisOrigen = respuesta.PaiCodOri;
              this.departamentoOrigen = respuesta.DepCodOri;
              this.ciudadOrigen = respuesta.CiuCodOri;
              this.paisResidencia = respuesta.PaiCodRes;
              this.departamentoResidencia = respuesta.DepCodRes;
              this.ciudadResidencia = respuesta.CiuCodRes;
              this.direccionResidencia = respuesta.PacDir;
              this.telefonoContacto = respuesta.PacTel;
              this.eps = respuesta.EpsCod;
              this.poliza = respuesta.PolCod;
              this.prepagada = respuesta.PreCod;
              this.regimen = respuesta.PacReg;
              this.estado = respuesta.estado;
              if (respuesta.PacNomAco == null) {
                this.nombreAcompanante = "";
              } else {
                this.nombreAcompanante = respuesta.PacNomAco;
              }
              this.telefonoAcompanante = respuesta.PacTelAco;
              if (respuesta.PacRem == null) {
                this.remitente = "";
              } else {
                this.remitente = respuesta.PacRem;
              }
              if (respuesta.url_foto != null) {
                this.fotoPaciente = this.ip + respuesta.url_foto;
              }
              this.controlBoton = "editar";
              this.PacIde = respuesta.PacIdeUsu;
              this.fotoEnviar = null;
              this.nombreFotoDocumento = respuesta.NomDoc;
              this.nombreFotoAcudiente = respuesta.NomAcu;
              this.nombreConsentimientoInfor = respuesta.NomCon;
              this.nombreordenMedica = respuesta.NomOrd;
              this.nombreAutorizacion = respuesta.NomAut;
              this.nombreimagen2 = respuesta.NomArc;
              this.UrlOrd = respuesta.UrlOrd;
              this.UrlCon = respuesta.UrlCon;
              this.UrlAut = respuesta.UrlAut;
              this.UrlArc = respuesta.UrlArc;
              this.UrlDoc = respuesta.UrlDoc;
              this.UrlAcu = respuesta.UrlAcu;
              this.emailContacto = respuesta.PacEma;

              this.llamarAcudientesDePaciente();
              this.calcularEdad();
              this.motivos();
            } else {
              var color = Math.floor(Math.random() * 4 + 1);
              this.$notify({
                component: {
                  template: ` <div style="padding: 3%;">
                      <p><b> NO SE ENCONTRARON REGISTROS </b>.</p>
                      </div>
                      `,
                },
                icon: "fa fa-info",
                horizontalAlign: "right",
                verticalAlign: "bottom",
                type: this.type[color],
                width: 100,
                height: 100,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
      }
    },

    llamarPacienteExistente2(paciente) {
      this.numeroDocumento = paciente.PacNumDoc;
      this.tipoDocumento = paciente.TipCod;

      setTimeout(() => {
        this.llamarPacienteExistente();
        this.cerrarModal();
        this.arrayPacientes = [];
        this.busqueda = "";
      }, 1000);
    },

    llamarAcudientesDePaciente() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/acudientes/" + this.PacIde;
      axios
        .get(url, config)
        .then((response) => {
          this.arrayAcudientes = [];
          var respuesta = response.data.data;
          for (var i = 0; i < respuesta.length; i++) {
            var respuesta1 = response.data.data[i][0];
            this.arrayAcudientes.push(respuesta1);
          }

          console.log(response.data.data);

          if (this.nombreAcompanante == "") {
            this.nombreAcompanante =
              response.data.data[0][0].TerNom +
              " " +
              response.data.data[0][0].TerApe;
            this.telefonoAcompanante = response.data.data[0][0].TerTel;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    calcularEdad() {
      if (this.Fecha_nacimiento != "") {
        var fechaNacimiento = this.Fecha_nacimiento;
        var values = fechaNacimiento.split("-");
        var dia = values[2];
        var mes = values[1];
        var ano = values[0];

        var fecha_hoy = new Date();
        var ahora_ano = fecha_hoy.getFullYear();
        var ahora_mes = fecha_hoy.getMonth() + 1;
        var ahora_dia = fecha_hoy.getDate();

        var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        // this.fechaIngreso = fechaActual;

        var edad = ahora_ano + 0 - ano;
        if (ahora_mes < mes) {
          edad--;
        }
        if (mes == ahora_mes && ahora_dia < dia) {
          edad--;
        }
        if (edad > 1900) {
          edad -= 1900;
        }

        // calculamos los meses
        var meses = 0;
        if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
        if (ahora_mes == mes && dia > ahora_dia) meses = 11;

        // calculamos los dias
        var dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
          var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
          var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        this.anos = edad;
        this.meses = meses;
      } else {
        this.anos = 0;
      }
      // this.calcularFechaActual();
    },

    calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaIngreso = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaIngreso = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },

    limpiarFormulario() {
      swal({
        title: "¿Seguro desea limpiar el formulario?",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then((result) => {
        this.calcularFechaActual();
        this.nombres = "";
        this.apellidos = "";
        this.fotoPaciente = [];
        this.nombrefotoPaciente = null;
        this.numeroDocumento = "";
        this.tipoVinculacion = "";
        this.tipoDocumento = 1;
        this.sexo = 1;
        this.paisOrigen = 1;
        this.tipoCliente = "";
        this.departamentoOrigen = 1;
        this.ciudadOrigen = 1;
        this.paisResidencia = 1;
        this.departamentoResidencia = 1;
        this.ciudadResidencia = 1;
        this.direccionResidencia = "";
        this.barrioResidencia = "";
        this.telefonoContacto = "";
        this.eps = 16;
        this.prepagada = 16;
        this.poliza = 16;
        this.nombreAcompanante = "";
        this.telefonoAcompanante = "";
        this.remitente = "";
        this.anos = 0;
        this.meses = 0;
        this.Fecha_nacimiento = "";
        this.estado = 1;
        this.controlBoton = "registrar";
        this.arrayAcudientes = [];
        this.PacIde = "";
        this.apellidosAcudiente = "";
        this.nombresAcudiente = "";
        this.documentoAcudiente = "";
        this.tipoDocumentoAcudiente = "";
        this.parentesco = "";
        this.telefonoAcudiente = "";
        this.correo = "";
        this.ocupacion = "";
        this.arrayAcudientes = [];
        this.nombreFotoDocumento = null;
        this.nombreFotoAcudiente = null;
        this.nombreConsentimientoInfor = null;
        this.nombreordenMedica = null;
        this.nombreAutorizacion = null;
        this.nombreimagen2 = null;
        this.arrayMotivo = [];
        this.nombreFotoDocumento = null;
        this.nombreFotoAcudiente = null;
        this.nombreConsentimientoInfor = null;
        this.nombreordenMedica = null;
        this.nombreAutorizacion = null;
        this.nombreimagen2 = null;
        this.motivoConsulta = "";
      });

      // alert(this.fotoPaciente);
    },

    limpiarFormulario2() {
      swal({
        title: "¿Seguro desea limpiar el formulario?",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then((result) => {
        this.apellidosAcudiente = "";
        this.nombresAcudiente = "";
        this.documentoAcudiente = "";
        this.tipoDocumentoAcudiente = "";
        this.parentesco = "";
        this.telefonoAcudiente = "";
        this.correo = "";
        this.ocupacion = "";
        this.arrayAcudientes = [];
        this.nombreFotoDocumento = null;
        this.nombreFotoAcudiente = null;
        this.nombreConsentimientoInfor = null;
        this.nombreordenMedica = null;
        this.nombreAutorizacion = null;
        this.nombreimagen2 = null;
      });
    },

    limpiarFormulario3() {
      swal({
        title: "¿Seguro desea limpiar el formulario?",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then((result) => {
        this.nombreFotoDocumento = null;
        this.nombreFotoAcudiente = null;
        this.nombreConsentimientoInfor = null;
        this.nombreordenMedica = null;
        this.nombreAutorizacion = null;
        this.nombreimagen2 = null;
        this.UrlCon = "";
        this.UrlDoc = "";
        this.UrlAcu = "";
        this.UrlArc = "";
        this.UrlOrd = "";
        this.UrlAut = "";
      });
    },

    eliminarAcudiente(acudiente) {
      var url =
        this.ip +
        "api/eliminarRelacion/" +
        this.PacIde +
        "/" +
        acudiente.TerIde;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      swal({
        title: "¿Seguro desea eliminar el registro?",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      }).then((result) => {
        axios
          .put(
            url,
            {
              paciente: this.PacIde,
              acudiente: acudiente.TerIde,
            },
            config
          )
          .then((response) => {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template:
                  "<span>" +
                  response.data.reaccion +
                  "! " +
                  response.data.mensaje +
                  "!<b></b>.</span>",
              },
              icon: "ti-" + response.data.icono,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type[color],
            });
            this.llamarAcudientesDePaciente();
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },

    nuevoMotivoConsulta() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/nuevoMotivo";
      if (this.PacIde != "") {
        if (this.motivoConsulta != "") {
          this.$modal.show("carga");
          axios
            .post(
              url,
              {
                MotFec: this.fechaActual,
                PacIde: this.PacIde,
                MotDes: this.motivoConsulta,
              },
              config
            )
            .then((response) => {
              this.$modal.hide("carga");
              var color = Math.floor(Math.random() * 4 + 1);
              this.$notify({
                component: {
                  template: `<div style="padding: 3%;">
                      <span>'<b>${response.data.mensaje.toUpperCase()}</b>.</span>
                      </div>
                      `,
                },
                icon: "fa fa-info",
                horizontalAlign: "right",
                verticalAlign: "bottom",
                type: this.type[color],
              });
              this.motivoConsulta = "";
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: `<div style="padding: 3%;">
                      <p><b>FALTAN DATOS DEL PACIENTE</b>. <br></p>
                      </div>`,
          },
          icon: "fa fa-info",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: this.type[color],
        });
      }
    },
    motivos() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/motivos/" + this.PacIde,
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.arrayMotivo = response.data.data;
          console.log(this.arrayMotivo);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    limpiarMotivoDeConsulta() {
      this.motivoConsulta = "";
    },
    abrirModal() {
      this.$modal.show("buscar");
      this.arrayPacientes = [];
      this.busqueda = "";
    },
    cerrarModal() {
      this.$modal.hide("buscar");
    },
  },

  mounted() {
    if (!localStorage.getItem("token")) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        component: {
          template: `<span>-<b> No tiene autorización para estár aquí</b>.</span>`,
        },
        icon: "ti-close",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: this.type[color],
      });
      this.$router.push("/");
    } else {
      this.selectCiudad();
      this.selectDepartamento();
      this.selectPais();
      this.selectEps();
      this.selectPrepagada();
      this.selectPoliza();
      this.selectTipoDocumento();
      this.selectTipoCliente();
      this.calcularFechaActual();
      // this.modalCarga();
      window.document.title = "Avanti: Ingreso de pacientes";
    }
  },
};
</script>
<style scoped>
#buttonImg {
  width: 300px;
  /* color: #e3097e;
  border: 1px #e3097e solid; */
}

#documentos {
  width: 170px;
  height: 150px;
}
#botonConImagen {
  width: 300px;
  color: white;
  background-color: #e3097e;
  border: 1px white solid;
}

small {
  color: red;
  font-size: 17px;
}

/* input:valid, textarea:valid {
  border-color:green;
}
input:invalid, textarea:invalid {
  border-color:red;
} */
.carga {
  padding-top: 25%;
}

.mostrar {
  display: list-item !important;
  opacity: 1 !important;
  position: absolute !important;
  background-color: #3c29297a;
}
.modal-content {
  width: 100% !important;
  position: absolute !important;
}

.titulo-modal {
  padding: 0px !important;
  margin: 0px !important;
}

.texto-pequeno {
  font-size: 15px;
  color: darkgray;
  padding: 0px !important;
  margin: 0px !important;
}

label {
  font-weight: normal;
}

.btn {
  border-radius: 7px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/Admisiones/Ingreso.vue